import React, { useLayoutEffect } from "react";
import { Modal } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { get } from "lodash";
import { useForm } from "react-hook-form";

import { TITLES } from "~/pages/ListOfDocuments/Modals/options";
import {
  DealerStatus,
  useGetMyDealersLazyQuery,
} from "~/schemas/generated/graphql";
import { Field } from "~/shared/ui/Field";

const createAdditionalArrFormId = "createAdditionalArrForm";

interface CreateContractIProps {
  open: boolean;
  onClose: () => void;
  dealerObj?: any;
}

// Массовое формирование доп. соглашений: submit пока заглушка (console.log),
// поэтому проп dealerObj оставлен в интерфейсе для совместимости вызовов.
const CreateAdditionalArr = ({ open, onClose }: CreateContractIProps) => {
  const [getMyDealersQuery, myDealers] = useGetMyDealersLazyQuery({
    variables: {
      page: 0,
      partName: null,
      count: 20000,
      statuses: DealerStatus.Active,
    },
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  useLayoutEffect(() => {
    getMyDealersQuery();
  }, []);

  const dealershipsForSelect = (
    get(myDealers, "data.DealerGetter.getMyDealers.items", []) as {
      id: number;
      DealerName: string;
    }[]
  ).map(({ id, DealerName }) => ({
    label: DealerName,
    value: id,
  }));

  const { control, handleSubmit } = useForm({
    defaultValues: { dealer: [], template: null },
  });

  const submit = (data) => {
    console.log(data);
  };

  return (
    <Modal
      open={open}
      title={TITLES.additional.createArr}
      onCancel={onClose}
      centered
      destroyOnHidden
      size="large"
      cancelButton={{ children: "Закрыть" }}
      okButton={{
        htmlType: "submit",
        form: createAdditionalArrFormId,
        children: "Сформировать",
      }}
    >
      <form
        id={createAdditionalArrFormId}
        onSubmit={handleSubmit(submit)}
        style={{ minHeight: "400px" }}
      >
        <Flex vertical gap={36}>
          <Field
            type="select"
            name="dealer"
            control={control}
            label="Дилеры"
            options={dealershipsForSelect}
            mode="multiple"
            labelInValue
          />
          <Field
            type="select"
            name="template"
            control={control}
            label="Выбрать шаблон"
            options={[]}
            labelInValue
          />
        </Flex>
      </form>
    </Modal>
  );
};

export default CreateAdditionalArr;
